export const LoginScreen = ({ onGoogleLogin, onGuestLogin, onBack }) => {
  return (
    <div
      className="relative w-full max-w-md h-[100dvh] sm:h-[700px] mx-auto overflow-hidden bg-gradient-to-b from-slate-900 via-indigo-950 to-slate-900 shadow-2xl sm:rounded-3xl sm:border-8 sm:border-white select-none"
      data-testid="login-screen"
    >
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-8">
        <h1 className="game-title text-3xl text-white mb-3" data-testid="login-title">
          Sign In to Play
        </h1>
        <p className="text-white/50 text-sm mb-8 text-center" style={{ fontFamily: 'Nunito, sans-serif' }}>
          Sign in to play online with players worldwide
        </p>

        <div className="w-full space-y-3 max-w-xs">
          {/* Google Login */}
          <button
            onClick={onGoogleLogin}
            className="w-full flex items-center gap-3 px-5 py-4 rounded-xl bg-white text-gray-800 font-semibold text-base shadow-lg hover:shadow-xl transition-all hover:scale-[1.02] active:scale-95"
            style={{ fontFamily: 'Nunito, sans-serif' }}
            data-testid="login-google"
          >
            <svg viewBox="0 0 24 24" width="22" height="22">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </button>

          {/* Facebook Login */}
          <button
            onClick={onGoogleLogin}
            className="w-full flex items-center gap-3 px-5 py-4 rounded-xl text-white font-semibold text-base shadow-lg hover:shadow-xl transition-all hover:scale-[1.02] active:scale-95"
            style={{ background: '#1877F2', fontFamily: 'Nunito, sans-serif' }}
            data-testid="login-facebook"
          >
            <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Continue with Facebook
          </button>

          {/* Divider */}
          <div className="flex items-center gap-3 py-2">
            <div className="flex-1 h-px bg-white/20" />
            <span className="text-white/40 text-xs" style={{ fontFamily: 'Nunito, sans-serif' }}>or</span>
            <div className="flex-1 h-px bg-white/20" />
          </div>

          {/* Guest */}
          <button
            onClick={onGuestLogin}
            className="w-full flex items-center justify-center gap-2 px-5 py-4 rounded-xl border-2 border-white/20 text-white/80 font-semibold text-base transition-all hover:border-white/40 hover:text-white hover:scale-[1.02] active:scale-95"
            style={{ fontFamily: 'Nunito, sans-serif' }}
            data-testid="login-guest"
          >
            Continue as Guest
          </button>
        </div>

        <button
          onClick={onBack}
          className="text-white/40 text-xs mt-6 hover:text-white/60 transition-colors"
          style={{ fontFamily: 'Nunito, sans-serif' }}
          data-testid="login-back"
        >
          &larr; Back
        </button>
      </div>
    </div>
  );
};
